import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, addDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ItemsList = () => {
    const [items, setItems] = useState([]);
    const [cart, setCart] = useState([]);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [orderDate, setOrderDate] = useState(new Date());
    const [comments, setComments] = useState('');
    const user = useSelector((state) => state.auth.currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/loginK');
            return;
        }

        const fetchItems = async () => {
            const itemsCollection = collection(db, 'items_clear');
            const itemsSnapshot = await getDocs(itemsCollection);
            const itemsList = itemsSnapshot.docs.map((doc) => ({
                ...doc.data(),
                borderColor: getRandomColor(), // Assign a random color for the border
            }));
            setItems(itemsList);
        };

        fetchItems();
    }, []);

    const changeBodyBackground = (background) => {
        document.body.style.background = background;
      };
    
    
      useEffect(() => {
        changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
        return () => changeBodyBackground(''); // Reset background on unmount
      }, []);
    

    const getRandomColor = () => {
        // Generate a random color for the border
        return `hsl(${Math.floor(Math.random() * 360)}, 70%, 80%)`;
    };

    const addToCart = (item, quantity) => {
        setCart([...cart, { ...item, quantity: parseInt(quantity, 10) }]);
    };

    const toggleCart = () => {
        setIsCartOpen(!isCartOpen);
    };

    const handleOrderCompletion = async () => {
        const order = {
            items: cart,
            orderDate: orderDate,
            comments: comments,
            timestamp: new Date(),
            status: 'new',
            user: user.username,
        };

        try {
            await addDoc(collection(db, 'orders'), order);
            console.log('Order saved successfully!');
            setCart([]); // Clear the cart after order completion
            setIsCartOpen(false); // Close the modal
        } catch (error) {
            console.error('Error saving order:', error);
        }
    };

    const handleViewOrders = () => {
        navigate('/my-orders');
    };

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    return (
        <div style={{ padding: '1rem' }}>
            <h1>קטלוג פרטים</h1>
            <div style={{ position: 'fixed', top: '10px', right: '10px', cursor: 'pointer', zIndex: 1000 }} onClick={toggleCart}>
                <FontAwesomeIcon icon={faShoppingCart} />
                <span style={{ marginLeft: '5px' }}>{cart.length}</span>
            </div>

            {/* Modal for Cart */}
            <Modal
                isOpen={isCartOpen}
                onRequestClose={toggleCart}
                contentLabel="Order Summary"
                style={{
                    content: {
                        maxWidth: '90%',
                        margin: 'auto',
                        padding: '2rem',
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                    },
                    overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                }}
            >
                <h2>פרטי ההזמנה</h2>
                <ul>
                    {cart.map((item, index) => (
                        <li key={index}>
                            {item.name} - כמות: {item.quantity}
                        </li>
                    ))}
                </ul>
                <div>
                    <p>תאריך נדרש לקבלת הציוד:</p>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="תאריך"
                            value={orderDate || null}
                            onChange={setOrderDate}
                            renderInput={(params) => <div {...params} />}
                        />
                    </LocalizationProvider>
                </div>
                <div>
                    <p>הערות:</p>
                    <textarea value={comments} onChange={(e) => setComments(e.target.value)} style={{ width: '100%', minHeight: '50px' }} />
                </div>
                <button onClick={handleOrderCompletion} style={{ marginTop: '1rem', padding: '0.5rem 1rem', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>סיום הזמנה</button>
            </Modal>

            {/* Items List */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {items.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0.5rem 1rem',
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                            maxHeight: '80px', // Adjusted height for additional text
                        }}
                    >
                        {/* Image with dynamic border color */}
                        <img
                            src={item.image}
                            alt={item.name}
                            style={{
                                width: '50px',  // Smaller image size
                                height: '50px',
                                objectFit: 'cover',
                                borderRadius: '50%', // Circular image
                                border: `2px solid ${item.borderColor}`, // Dynamic border color
                                flexShrink: 0, // Prevent image from shrinking
                            }}
                        />
                        {/* Product Details */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: '50%' }}>
                            <h2 style={{ fontSize: '1rem', fontWeight: 'bold', margin: '0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</h2>
                            <p style={{ fontSize: '0.85rem', color: '#666', margin: '0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{truncateText(item.description, 70)}</p> {/* Truncated description */}
                            <div style={{ fontSize: '0.85rem', color: item.isAvailable ? '#4caf50' : '#f44336' }}>{item.isAvailable ? 'במלאי' : 'לא במלאי'}</div>
                        </div>
                        {/* Quantity and Cart Button */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
                            <input
                                type="number"
                                min="1"
                                defaultValue="1"
                                id={`quantity-${index}`}
                                style={{
                                    width: '50px',
                                    padding: '0.3rem',
                                }}
                            />
                            <button
                                onClick={() => addToCart(item, document.getElementById(`quantity-${index}`).value)}
                                style={{
                                    backgroundColor: item.isAvailable ? '#007bff' : '#d3d3d3', // Disabled color if not available
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '5px',
                                    padding: '0.3rem 0.6rem',
                                    cursor: item.isAvailable ? 'pointer' : 'not-allowed', // Disable cursor if not available
                                }}
                                disabled={!item.isAvailable} // Disable button if not available
                            >
                                <FontAwesomeIcon icon={faShoppingCart} />
                            </button>
                        </div>
                    </div>
                ))}
                <button onClick={handleViewOrders} style={{ marginTop: '1rem', padding: '0.5rem 1rem', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>הצג את ההזמנות שלי</button>
            </div>
        </div>
    );
};

export default ItemsList;
